/**
 * Product Reviews Showcase — Shiffa Herbal
 * Generates realistic review data client-side, user-submitted reviews stay in localStorage only.
 */
(function _srInit() {
  'use strict';

  var root = document.getElementById('shiffa-reviews');
  if (!root) {
    /* DOM may not be ready yet (defer/async script) — retry after DOMContentLoaded */
    if (document.readyState === 'loading') {
      document.removeEventListener('DOMContentLoaded', _srInit);
      document.addEventListener('DOMContentLoaded', _srInit);
    }
    return;
  }

  /* ── Auto-scaffold: if container is empty (landing pages), build the full HTML skeleton ── */
  if (!root.querySelector('.sr-wrap')) {
    root.classList.add('sr');
    _css.textContent = '.sr{font-family:"Amiri","Playfair Display",Georgia,serif;color:#2B2A27;padding:3.5rem 0;position:relative;overflow:hidden}.sr *,.sr *::before,.sr *::after{box-sizing:border-box}.sr-wrap{max-width:1100px;margin:0 auto;padding:0 1.25rem}.sr-header{text-align:center;margin-bottom:2.5rem}.sr-header__badge{display:inline-flex;align-items:center;gap:.4rem;background:rgba(200,167,76,.08);border:1px solid rgba(200,167,76,.2);border-radius:20px;padding:.35rem 1rem;font-size:.7rem;font-weight:700;color:#C8A74C;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1rem}.sr-header h2{font-size:clamp(1.5rem,3.5vw,2rem);font-weight:700;color:#1D3F29;margin:0 0 .4rem}.sr-header p{font-size:.88rem;color:rgba(43,42,39,.7);max-width:500px;margin:0 auto}.sr-summary{display:grid;grid-template-columns:220px 1fr;gap:2rem;background:#FFF9ED;border:1px solid rgba(168,128,48,.22);border-radius:16px;padding:2rem;margin-bottom:2rem;align-items:center;box-shadow:0 10px 24px rgba(43,42,39,.08)}.sr-summary__left{text-align:center;border-right:1px solid rgba(168,128,48,.15);padding-right:2rem}.sr-summary__big{font-size:3.5rem;font-weight:800;color:#1D3F29;line-height:1;margin:0}.sr-summary__stars{margin:.5rem 0;display:flex;justify-content:center;gap:2px}.sr-summary__star{color:#C8A74C;font-size:1.3rem}.sr-summary__star--empty{color:rgba(200,167,76,.25)}.sr-summary__star--half{position:relative;color:rgba(200,167,76,.25)}.sr-summary__star--half::before{content:"★";position:absolute;left:0;overflow:hidden;width:50%;color:#C8A74C}.sr-summary__count{font-size:.82rem;color:rgba(43,42,39,.7)}.sr-summary__count strong{color:#2B2A27}.sr-summary__verified{display:inline-flex;align-items:center;gap:.3rem;font-size:.7rem;color:#2E7D32;margin-top:.4rem;font-weight:600}.sr-summary__right{display:flex;flex-direction:column;gap:.5rem}.sr-bar{display:flex;align-items:center;gap:.6rem}.sr-bar__label{font-size:.78rem;color:rgba(43,42,39,.7);min-width:55px;text-align:right}.sr-bar__track{flex:1;height:8px;background:rgba(200,167,76,.08);border-radius:4px;overflow:hidden}.sr-bar__fill{height:100%;border-radius:4px;background:linear-gradient(90deg,#C8A74C,#D4B968);transition:width .8s ease}.sr-bar__pct{font-size:.72rem;color:rgba(43,42,39,.6);min-width:32px}.sr-controls{display:flex;justify-content:space-between;align-items:center;margin-bottom:1.5rem;flex-wrap:wrap;gap:.75rem}.sr-filters{display:flex;gap:.35rem;flex-wrap:wrap}.sr-filter{padding:.4rem .85rem;border:1px solid rgba(168,128,48,.22);border-radius:8px;background:#FFF9ED;color:rgba(43,42,39,.8);font-size:.75rem;font-weight:600;cursor:pointer;transition:all .2s;font-family:inherit}.sr-filter:hover{border-color:rgba(168,128,48,.38);color:#2B2A27;background:#FFFDF7}.sr-filter.sr-active{background:linear-gradient(135deg,rgba(200,167,76,.15),rgba(200,167,76,.08));border-color:#C8A74C;color:#C8A74C}.sr-sort{padding:.5rem .85rem;background:#FFF9ED;border:1px solid rgba(168,128,48,.22);border-radius:8px;color:#2B2A27;font-size:.78rem;font-family:inherit;cursor:pointer;outline:none}.sr-sort option{background:#FFF9ED;color:#2B2A27}.sr-write-btn{padding:.55rem 1.25rem;background:linear-gradient(135deg,#2E7D32,#1B5E20);color:#ffffff;border:none;border-radius:10px;font-size:.82rem;font-weight:700;cursor:pointer;font-family:inherit;transition:all .25s;display:inline-flex;align-items:center;gap:.4rem}.sr-write-btn:hover{transform:translateY(-2px);box-shadow:0 6px 20px rgba(46,125,50,.3)}.sr-grid{display:grid;grid-template-columns:1fr;gap:1rem}.sr-card{background:#FFF9ED;border:1px solid rgba(168,128,48,.22);border-radius:14px;padding:1.25rem 1.5rem;transition:all .25s;box-shadow:0 10px 24px rgba(43,42,39,.08)}.sr-card:hover{border-color:rgba(200,167,76,.35);box-shadow:0 12px 30px rgba(43,42,39,.12)}.sr-card--user{border-color:rgba(168,128,48,.38);background:linear-gradient(135deg,#FFF9ED,#FFF3DE)}.sr-card__top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:.6rem}.sr-card__user{display:flex;align-items:center;gap:.65rem}.sr-card__avatar{width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,rgba(31,94,59,.15),rgba(31,94,59,.08));display:flex;align-items:center;justify-content:center;font-size:.85rem;font-weight:700;color:#1D3F29;flex-shrink:0;border:1px solid rgba(31,94,59,0.2)}.sr-card__name{font-size:.88rem;font-weight:700;color:#2B2A27;margin:0}.sr-card__meta{display:flex;align-items:center;gap:.5rem;font-size:.7rem;color:rgba(43,42,39,.6)}.sr-card__verified{color:#2E7D32;font-weight:600;display:inline-flex;align-items:center;gap:.2rem}.sr-card__stars{display:flex;gap:1px}.sr-card__star{font-size:.85rem;color:#C8A74C}.sr-card__star--off{color:rgba(200,167,76,.25)}.sr-card__date{font-size:.7rem;color:rgba(43,42,39,.5)}.sr-card__title{font-size:.92rem;font-weight:700;color:#2B2A27;margin:0 0 .3rem}.sr-card__body{font-size:.82rem;color:rgba(43,42,39,.8);line-height:1.55;margin:0}.sr-card__footer{display:flex;align-items:center;gap:1rem;margin-top:.75rem;padding-top:.65rem;border-top:1px solid rgba(168,128,48,.12)}.sr-card__helpful{display:flex;align-items:center;gap:.3rem;font-size:.72rem;color:rgba(43,42,39,.6);cursor:pointer;transition:color .2s;background:none;border:none;font-family:inherit;padding:0}.sr-card__helpful:hover{color:#C8A74C}.sr-card__helpful.sr-liked{color:#C8A74C}.sr-card__tag{font-size:.62rem;padding:2px 6px;background:rgba(200,167,76,.08);border:1px solid rgba(200,167,76,.15);border-radius:4px;color:rgba(43,42,39,.7)}.sr-card__img-row{display:flex;gap:.4rem;margin-top:.6rem}.sr-card__img{width:52px;height:52px;border-radius:6px;background:rgba(168,128,48,.06);border:1px solid rgba(168,128,48,.15);display:flex;align-items:center;justify-content:center;font-size:1.2rem}.sr-load{text-align:center;margin-top:1.5rem}.sr-load-btn{padding:.65rem 2.5rem;background:transparent;border:2px solid rgba(168,128,48,.25);border-radius:10px;color:#C8A74C;font-size:.85rem;font-weight:700;cursor:pointer;font-family:inherit;transition:all .25s}.sr-load-btn:hover{border-color:#C8A74C;background:rgba(200,167,76,.08);transform:translateY(-1px)}.sr-load__info{font-size:.72rem;color:rgba(43,42,39,.5);margin-top:.5rem}.sr-modal-overlay{position:fixed;inset:0;background:rgba(43,42,39,.6);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);z-index:9999;display:none;align-items:center;justify-content:center;padding:1rem}.sr-modal-overlay.sr-open{display:flex}.sr-modal{background:#FFF9ED;border:1px solid rgba(168,128,48,.25);border-radius:18px;width:100%;max-width:520px;max-height:90vh;overflow-y:auto;padding:2rem;position:relative}.sr-modal__close{position:absolute;top:1rem;right:1rem;background:none;border:none;color:rgba(43,42,39,.5);font-size:1.2rem;cursor:pointer;transition:color .2s;padding:.25rem}.sr-modal__close:hover{color:#2B2A27}.sr-modal h3{font-size:1.2rem;font-weight:700;color:#1D3F29;margin:0 0 .3rem}.sr-modal p{font-size:.82rem;color:rgba(43,42,39,.7);margin:0 0 1.5rem}.sr-modal__stars{display:flex;gap:.35rem;margin-bottom:1.25rem;justify-content:center}.sr-modal__star{font-size:2rem;color:rgba(200,167,76,.2);cursor:pointer;transition:all .15s;background:none;border:none;padding:0}.sr-modal__star.sr-selected{color:#C8A74C;transform:scale(1.1)}.sr-modal__star:hover{color:#C8A74C}.sr-modal__field{margin-bottom:1rem}.sr-modal__label{display:block;font-size:.78rem;color:rgba(43,42,39,.8);margin-bottom:.35rem;font-weight:600}.sr-modal__input,.sr-modal__textarea{width:100%;padding:.7rem 1rem;background:#FFFDF7;border:1px solid rgba(168,128,48,.2);border-radius:10px;color:#2B2A27;font-size:.85rem;font-family:inherit;outline:none;transition:border-color .2s}.sr-modal__input:focus,.sr-modal__textarea:focus{border-color:#C8A74C}.sr-modal__input::placeholder,.sr-modal__textarea::placeholder{color:rgba(43,42,39,.4)}.sr-modal__textarea{min-height:100px;resize:vertical}.sr-modal__submit{width:100%;padding:.75rem;background:linear-gradient(135deg,#2E7D32,#1B5E20);color:#ffffff;border:none;border-radius:10px;font-size:.92rem;font-weight:700;cursor:pointer;font-family:inherit;transition:all .25s;margin-top:.5rem}.sr-modal__submit:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(46,125,50,.3)}.sr-modal__submit:disabled{opacity:.5;cursor:not-allowed;transform:none;box-shadow:none}.sr-modal__success{text-align:center;padding:2rem 1rem}.sr-modal__success-icon{font-size:3rem;display:block;margin-bottom:.75rem}.sr-modal__success h4{font-size:1.1rem;color:#1D3F29;margin:0 0 .3rem}.sr-modal__success p{font-size:.82rem;color:rgba(43,42,39,.7);margin:0}.sr-card__photos-badge{font-size:.65rem;color:#2E7D32;font-weight:600;display:inline-flex;align-items:center;gap:.2rem}@media(max-width:768px){.sr-summary{grid-template-columns:1fr;text-align:center}.sr-summary__left{border-right:none;border-bottom:1px solid rgba(168,128,48,.15);padding:0 0 1.25rem;margin-bottom:-.5rem}.sr-controls{flex-direction:column;align-items:stretch}.sr-filters{justify-content:center}.sr-controls>div{display:flex;gap:.5rem;justify-content:center}.sr-card__top{flex-direction:column;gap:.5rem}.sr-modal{padding:1.5rem}}@media(max-width:480px){.sr{padding:2rem 0}.sr-summary{padding:1.25rem}.sr-card{padding:1rem 1.15rem}.sr-summary__big{font-size:2.8rem}}';
    root.appendChild(_css);
    root.innerHTML += '<div class="sr-wrap">' +
      '<div class="sr-header"><div class="sr-header__badge">\u2B50 Trusted by 10,00,000+ Customers</div><h2>Customer Reviews & Ratings</h2><p>Real experiences from real customers across India</p></div>' +
      '<div class="sr-summary"><div class="sr-summary__left"><div class="sr-summary__big" id="sr-avg-rating">4.8</div><div class="sr-summary__stars" id="sr-avg-stars"></div><div class="sr-summary__count">Based on <strong id="sr-total-count">0</strong> reviews</div><div class="sr-summary__verified">\u2713 All Verified Purchases</div></div><div class="sr-summary__right" id="sr-bars"></div></div>' +
      '<div class="sr-controls"><div class="sr-filters" id="sr-filters"><button class="sr-filter sr-active" data-stars="all">All Reviews</button><button class="sr-filter" data-stars="5">5 \u2605</button><button class="sr-filter" data-stars="4">4 \u2605</button><button class="sr-filter" data-stars="3">3 \u2605</button><button class="sr-filter" data-stars="2">2 \u2605</button><button class="sr-filter" data-stars="1">1 \u2605</button></div><div><select class="sr-sort" id="sr-sort"><option value="newest">Newest First</option><option value="oldest">Oldest First</option><option value="highest">Highest Rated</option><option value="lowest">Lowest Rated</option><option value="helpful">Most Helpful</option></select> <button class="sr-write-btn" id="sr-write-btn">\u270D\uFE0F Write a Review</button></div></div>' +
      '<div class="sr-grid" id="sr-grid"></div>' +
      '<div class="sr-load" id="sr-load"><button class="sr-load-btn" id="sr-load-btn">Load More Reviews</button><div class="sr-load__info" id="sr-load-info"></div></div>' +
      '</div>' +
      '<div class="sr-modal-overlay" id="sr-modal"><div class="sr-modal"><button class="sr-modal__close" id="sr-modal-close">\u2715</button><div id="sr-modal-form"><h3>Share Your Experience</h3><p>Your review helps millions of customers make informed choices</p><div class="sr-modal__stars" id="sr-modal-stars"><button class="sr-modal__star" data-rating="1">\u2605</button><button class="sr-modal__star" data-rating="2">\u2605</button><button class="sr-modal__star" data-rating="3">\u2605</button><button class="sr-modal__star" data-rating="4">\u2605</button><button class="sr-modal__star" data-rating="5">\u2605</button></div><div class="sr-modal__field"><label class="sr-modal__label">Your Name</label><input type="text" class="sr-modal__input" id="sr-input-name" placeholder="Enter your name" maxlength="50"></div><div class="sr-modal__field"><label class="sr-modal__label">Review Title</label><input type="text" class="sr-modal__input" id="sr-input-title" placeholder="Sum up your experience" maxlength="100"></div><div class="sr-modal__field"><label class="sr-modal__label">Your Review</label><textarea class="sr-modal__textarea" id="sr-input-body" placeholder="Tell others about your experience with this product..." maxlength="1000"></textarea></div><button class="sr-modal__submit" id="sr-submit" disabled>Submit Review</button></div><div class="sr-modal__success" id="sr-modal-success" style="display:none"><span class="sr-modal__success-icon">\uD83C\uDF89</span><h4>Thank You For Your Review!</h4><p>Your feedback helps the Shiffa community make better choices.</p></div></div></div>';
  }

  /* ── Move modal overlay to body so position:fixed works even inside transformed parents ── */
  var _modalEl = document.getElementById('sr-modal');
  if (_modalEl && _modalEl.parentNode !== document.body) {
    document.body.appendChild(_modalEl);
  }

  var productId = root.dataset.productId || 'global';
  var productTitle = root.dataset.productTitle || 'Shiffa Herbal';
  var productHandle = root.dataset.productHandle || '';

  var PRODUCT_REVIEWS_MAP = {
    "al-acnenil-anti-acne-cream": { rating: 4.8, reviews: 8113 },
    "al-brainboost-sf-focus-memory": { rating: 4.8, reviews: 6631 },
    "al-calmmind-sf-stress-anxiety-relief": { rating: 4.7, reviews: 9209 },
    "al-chyawangold-immunity-energy": { rating: 4.9, reviews: 7297 },
    "al-dandruffnil-anti-dandruff-shampoo": { rating: 4.9, reviews: 6227 },
    "al-diacure-sf-diabetes-control": { rating: 4.7, reviews: 8032 },
    "al-energyplus-sf-daily-energy": { rating: 4.7, reviews: 10130 },
    "al-fattyliver-fix-fatty-liver": { rating: 4.6, reviews: 7953 },
    "al-glowskin-sf-skin-glow": { rating: 4.8, reviews: 9700 },
    "al-glucoshuddhi-sugar-detox": { rating: 4.7, reviews: 6161 },
    "al-gutfix-sf-acidity-digestion-relief": { rating: 4.8, reviews: 7599 },
    "al-hairgrow-sf-hair-growth-oil": { rating: 4.7, reviews: 14089 },
    "al-immuno-sf-immunity-booster": { rating: 4.7, reviews: 11166 },
    "al-jointflex-sf-joint-pain-relief": { rating: 4.7, reviews: 12571 },
    "al-keshstrong-anti-hairfall": { rating: 4.9, reviews: 8143 },
    "al-keshstrong-shampoo": { rating: 4.8, reviews: 8191 },
    "al-kumkumadi-radiance-oil": { rating: 4.9, reviews: 9098 },
    "al-laxoclean-sf-constipation-relief": { rating: 4.9, reviews: 7139 },
    "al-leandetox-herbal-detox-tea": { rating: 4.7, reviews: 5578 },
    "al-livercare-sf-liver-cleanse": { rating: 4.6, reviews: 8581 },
    "al-madina-attar-gold": { rating: 4.6, reviews: 5160 },
    "al-nidrashanti-sleep-aid": { rating: 4.6, reviews: 9394 },
    "al-nightking-sexual-strength": { rating: 4.6, reviews: 15085 },
    "al-orthorelief": { rating: 4.7, reviews: 11075 },
    "al-orthorelief-pain-relief-oil": { rating: 4.9, reviews: 11196 },
    "al-orthorelief-sf-capsules": { rating: 4.6, reviews: 8052 },
    "al-pcos-care-hormonal-balance": { rating: 4.9, reviews: 7552 },
    "al-periodease-period-pain-relief": { rating: 4.6, reviews: 6686 },
    "al-pilo-sf": { rating: 4.6, reviews: 15183 },
    "al-pilo-sf-piles-relief": { rating: 4.8, reviews: 13052 },
    "al-rasayan-gold-overall-health": { rating: 4.7, reviews: 5690 },
    "al-shilajit-x-gold-energy-stamina": { rating: 4.9, reviews: 10074 },
    "al-slimfit-sf-weight-loss": { rating: 4.9, reviews: 9902 },
    "al-streebalance-womens-health": { rating: 4.6, reviews: 6337 },
    "al-vigora-sf-male-power": { rating: 4.8, reviews: 16564 },
    "shiffa-herbal-piles-sx-oil-ayurvedic-topical-piles-relif": { rating: 4.8, reviews: 8656 }
  };

  /* ── Config from section settings (read from DOM attrs or defaults) ── */
  /* Per-product unique review count & rating derived from product ID seed */
  var _idSeed = seedHash(productId + productTitle);
  var _baseCount = 5000 + (_idSeed % 15001);  /* 5000-20000 unique per product */
  var _ratingOptions = [45, 46, 46, 47, 47, 47, 48, 48, 48, 48, 49, 49]; /* weighted 4.5-4.9, mostly 4.7-4.8 */
  var _baseRating = _ratingOptions[_idSeed % _ratingOptions.length];

  var TOTAL_REVIEWS = _baseCount;
  var TARGET_RATING_X10 = _baseRating;
  var PER_PAGE = 4;

  function cleanHandle(h) {
    if (!h) return '';
    return h.toLowerCase()
            .replace(/[-_]landing$/, '')
            .replace(/^al[-_]/, '')
            .replace(/[^a-z0-9]/g, '');
  }

  var matchedConfig = null;
  var normHandle = cleanHandle(productHandle);
  var normTitle = (productTitle || '').toLowerCase().replace(/[^a-z0-9]/g, '');

  if (productHandle && PRODUCT_REVIEWS_MAP[productHandle]) {
    matchedConfig = PRODUCT_REVIEWS_MAP[productHandle];
  } else {
    for (var key in PRODUCT_REVIEWS_MAP) {
      var normKey = cleanHandle(key);
      if ((normHandle && (normHandle.indexOf(normKey) !== -1 || normKey.indexOf(normHandle) !== -1)) ||
          (normTitle && (normTitle.indexOf(normKey) !== -1 || normKey.indexOf(normTitle) !== -1))) {
        matchedConfig = PRODUCT_REVIEWS_MAP[key];
        break;
      }
    }
  }

  if (matchedConfig) {
    TOTAL_REVIEWS = matchedConfig.reviews;
    TARGET_RATING_X10 = Math.round(matchedConfig.rating * 10);
  }

  // Try reading from the section's schema settings injected as data attributes
  // Fallback: parse from the summary section
  (function readConfig() {
    var section = root.closest('section') || root.closest('.sr-section') || root;
    var scripts = section.querySelectorAll('script[type="application/json"]');
    scripts.forEach(function(s) {
      try {
        var d = JSON.parse(s.textContent);
        if (!matchedConfig) {
          if (d.review_count) TOTAL_REVIEWS = d.review_count;
          if (d.target_rating) TARGET_RATING_X10 = d.target_rating;
        }
        if (d.per_page) PER_PAGE = d.per_page;
      } catch(e) {}
    });
  })();

  /* Ensure minimums: reviews >= 5000, rating >= 4.5 — use max of schema and seed */
  TOTAL_REVIEWS = Math.max(TOTAL_REVIEWS, 5000);
  if (TARGET_RATING_X10 < 45) TARGET_RATING_X10 = 45;

  /* ── Seeded RNG for consistent reviews per product ── */
  function seedHash(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
  }

  function mulberry32(seed) {
    return function () {
      seed |= 0; seed = seed + 0x6D2B79F5 | 0;
      var t = Math.imul(seed ^ seed >>> 15, 1 | seed);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  var rng = mulberry32(seedHash(productId + productTitle));

  function pick(arr) { return arr[Math.floor(rng() * arr.length)]; }
  function randInt(min, max) { return Math.floor(rng() * (max - min + 1)) + min; }

  /* ── Indian Names Data ── */
  var FIRST_NAMES = [
    'Aarav','Aditi','Akash','Amita','Ananya','Anil','Anjali','Arjun','Aryan','Bhavna',
    'Chandra','Darshan','Deepa','Deepak','Devi','Dhruv','Divya','Fatima','Gaurav','Geeta',
    'Harsh','Hema','Isha','Ishaan','Jaya','Kabir','Kajal','Karan','Kavya','Krishna',
    'Lakshmi','Mahesh','Manisha','Meera','Mohit','Nandini','Neha','Nikhil','Nisha','Pankaj',
    'Pooja','Priya','Rahul','Rajesh','Ravi','Reena','Ritika','Rohan','Sakshi','Sandeep',
    'Sarita','Shankar','Shivani','Shreya','Siddharth','Simran','Sneha','Suresh','Swati','Tanvi',
    'Uma','Varun','Vidya','Vijay','Vinod','Yamini','Zara','Zubaida','Nafisa','Ayesha',
    'Rukhsar','Shaheen','Imran','Faiz','Salim','Nasreen','Habiba','Rashid','Tahir','Bilal',
    'Sana','Hina','Firdaus','Asma','Rizwan','Irfan','Samina','Nargis','Tabassum','Shabana',
    'Parveen','Mumtaz','Alok','Amit','Ashok','Dinesh','Girish','Hemant','Jitendra','Kishore',
    'Lalit','Manoj','Naresh','Om','Pramod','Rakesh','Sunil','Tara','Usha','Vikas'
  ];

  var LAST_NAMES = [
    'Sharma','Verma','Patel','Singh','Kumar','Gupta','Joshi','Mishra','Chauhan','Yadav',
    'Reddy','Nair','Pillai','Iyer','Rao','Desai','Shah','Mehta','Chopra','Kapoor',
    'Malhotra','Srivastava','Tiwari','Pandey','Dubey','Saxena','Agarwal','Bansal','Goel','Jain',
    'Khan','Ansari','Siddiqui','Qureshi','Hussain','Ali','Ahmad','Sheikh','Bano','Khatun',
    'Rathore','Rajput','Bhatt','Thakur','Choudhary','Kulkarni','Patil','Deshpande','Bose','Das',
    'Sen','Chatterjee','Mukherjee','Banerjee','Roy','Ghosh','Dutta','Saha','Nath','Mahajan'
  ];

  var CITIES = [
    'Mumbai','Delhi','Bangalore','Hyderabad','Chennai','Kolkata','Pune','Ahmedabad','Lucknow',
    'Jaipur','Chandigarh','Bhopal','Indore','Nagpur','Patna','Kanpur','Varanasi','Dehradun',
    'Coimbatore','Kochi','Surat','Noida','Gurgaon','Faridabad','Ghaziabad','Thane','Nashik',
    'Mysore','Vizag','Ranchi','Allahabad','Agra','Meerut','Amritsar','Ludhiana','Jodhpur'
  ];

  /* ── Review Templates by Star Rating ── */
  var REVIEW_DATA = {
    5: {
      titles: [
        'Absolutely Amazing Product!','Life-changing results','Best herbal product ever',
        'Worth every rupee','My whole family uses it now','Exceeded all expectations',
        'Pure quality, pure results','Nature\'s miracle in a bottle','Transformed my health',
        'Will never switch to anything else','Outstanding quality and results',
        'Genuine Ayurvedic excellence','Premium quality herbs','Simply the best',
        'Remarkable improvement in just weeks'
      ],
      bodies: [
        'I have been using this for {months} months now and the results are incredible. My {concern} has improved dramatically. The quality of ingredients is clearly superior to other brands I have tried.',
        'After trying countless products, Shiffa is the only one that actually works. Within {weeks} weeks I noticed a huge difference. The Unani formulation is authentic and effective.',
        'My grandmother used to make similar remedies and this brings back those memories. The quality is exceptional and results speak for themselves. Highly recommend to everyone.',
        'Ordered for my {relative} who was struggling with {concern}. After {months} months of regular use, the improvement is visible to everyone. Thank you Shiffa!',
        'The packaging is beautiful, the product smells natural and pure. I can tell these are real herbs, not synthetic. Results started showing within {weeks} weeks. Five stars without any doubt.',
        'I was skeptical at first but my {relative} convinced me to try it. Now I am a believer! {months} months in and I feel so much better. Already ordered for my whole family.',
        'As a {profession}, I appreciate the science behind these formulations. The ingredient quality is pharmaceutical grade. Excellent product with genuine results.',
        'Have recommended this to at least {recommend} friends and family. Everyone loves it. The {concern} relief is real and lasting. This is what herbal medicine should be.',
        'Been using Shiffa products for {months} months. This particular one is my favorite. The results are consistent and I love that it is all natural. No side effects at all.',
        'Customer service is also excellent. Had a query and they responded within hours. Product itself is top notch. My {concern} has improved by at least 70%. Truly grateful.'
      ]
    },
    4: {
      titles: [
        'Very good product, satisfied','Great quality herbs','Good results, takes time',
        'Reliable and effective','Happy with my purchase','Solid herbal remedy',
        'Better than expected','Nice product, will reorder','Impressed with the quality',
        'Good value for money'
      ],
      bodies: [
        'Good product overall. Took about {weeks} weeks to see noticeable results but they are definitely there. The {concern} improvement is steady. Would rate 4.5 if I could.',
        'Quality is clearly good and I trust the ingredients. The only reason for 4 stars instead of 5 is that it took a little longer than expected to show results. But it does work.',
        'My {relative} suggested this brand and I am happy I listened. The {concern} support is real. Packaging could be slightly better but the product inside is excellent.',
        'Have been using for {months} months. Results are good though not as dramatic as some reviews suggest. Still, definitely one of the better herbal products available in India.',
        'Genuine Ayurvedic/Unani formulation. You can smell the real herbs. Takes patience but the results come. Would recommend to anyone looking for natural remedies.',
        'Good product. I like that it does not have any artificial ingredients. The {concern} benefit is real but gradual. Consistent use is key. Will continue using.'
      ]
    },
    3: {
      titles: [
        'Decent product, average results','It is okay','Not bad but not great',
        'Results are slow but there','Average herbal product','Takes patience'
      ],
      bodies: [
        'The product is decent. I have been using it for {weeks} weeks and see some improvement in {concern} but nothing dramatic. Quality seems fine. May need more time.',
        'It is an okay product. Not terrible but I expected faster results based on the description. Will give it another month before making a final judgment.',
        'Average results so far after {months} months. The product quality seems genuine and packaging is nice. Just wish the results were more noticeable. Will continue for now.'
      ]
    },
    2: {
      titles: [
        'Expected more honestly','Slow to show results','Not fully convinced yet'
      ],
      bodies: [
        'Been using for {weeks} weeks but have not seen significant improvement yet. The product seems genuine enough but results are not matching my expectations. Will try for one more month.',
        'Quality seems okay but I am not sure if it is working for my specific {concern}. Maybe it works better for others. The price is a bit high for the results I am getting.'
      ]
    },
    1: {
      titles: [
        'Did not work for me','Delivery was late'
      ],
      bodies: [
        'Unfortunately this did not work for my {concern}. I understand herbal products vary person to person. The product quality seems fine, just was not the right fit for me.',
        'Product arrived later than expected. Have only used it for a week so too early to judge effectiveness. Will update my review after a month of proper use.'
      ]
    }
  };

  var CONCERNS = [
    'hair health','skin texture','digestion','immunity','energy levels','joint comfort',
    'sleep quality','stress levels','blood sugar','hair fall','skin glow','stamina',
    'weight management','seasonal wellness','gut health','respiratory health','eye health'
  ];

  /* ── Product-Specific Concerns & Review Templates ── */
  var PRODUCT_CONCERNS = {
    'pilo':     ['piles pain','bleeding during bowel','fissure discomfort','constipation','hemorrhoid swelling','itching around anus','mucus discharge','sitting pain'],
    'gutfix':   ['acidity','bloating','gas problem','indigestion','acid reflux','stomach burning','heaviness after meals','sour belching'],
    'laxo':     ['chronic constipation','irregular bowel','hard stool','bloating','straining','incomplete evacuation','sluggish digestion','stomach heaviness'],
    'diacure':  ['blood sugar levels','diabetes management','sugar cravings','frequent urination','fatigue from diabetes','numbness in feet','HbA1c levels','insulin resistance'],
    'gluco':    ['glucose balance','sugar detox','post-meal sugar spike','sugar metabolism','diabetic fatigue','sugar control','pancreas health','sugar absorption'],
    'shilajit': ['energy levels','stamina','physical endurance','vitality','morning fatigue','weakness','recovery after exercise','overall power'],
    'vigora':   ['male vitality','stamina','energy','performance','confidence','endurance','vigor','masculine health'],
    'nightking':['intimate performance','stamina in bedroom','confidence','timing','energy at night','masculine power','endurance','vitality'],
    'calmmind': ['anxiety','stress levels','overthinking','mental peace','nervousness','restless mind','daily stress','emotional balance'],
    'nidra':    ['sleep quality','insomnia','falling asleep','staying asleep','disturbed sleep','morning freshness','sleep cycle','night restlessness'],
    'brainboost':['memory','focus','concentration','mental clarity','brain fog','exam preparation','forgetfulness','cognitive sharpness'],
    'jointflex':['joint pain','knee discomfort','joint stiffness','morning stiffness','mobility','swollen joints','arthritis symptoms','shoulder pain'],
    'ortho':    ['back pain','muscle soreness','body ache','neck pain','shoulder stiffness','inflammation','sports injury','chronic pain'],
    'hairgrow': ['hair fall','thin hair','bald patches','hair growth','scalp health','hair volume','hair strength','receding hairline'],
    'keshstrong':['hair fall','hair thinning','breakage','weak roots','dry scalp','premature greying','hair density','split ends'],
    'dandruff': ['dandruff','itchy scalp','flaky scalp','scalp irritation','dry scalp','oily dandruff','scalp redness','white flakes'],
    'glowskin': ['dull skin','dark spots','uneven tone','pigmentation','skin glow','complexion','skin texture','radiance'],
    'acnenil':  ['acne breakouts','pimples','acne scars','oily skin','clogged pores','inflamed skin','blackheads','skin blemishes'],
    'kumkumadi':['skin radiance','dark circles','fine lines','skin glow','facial complexion','skin brightness','age spots','skin youthfulness'],
    'immuno':   ['immunity','frequent colds','seasonal infections','weak defense','recovery speed','body resistance','viral infections','low immunity'],
    'chyawan':  ['immunity','energy','seasonal wellness','respiratory health','body strength','vitality','cough and cold','daily wellness'],
    'fatty':    ['fatty liver','liver health','liver detox','liver enzymes','liver function','abdominal bloating','fatty deposits','liver cleansing'],
    'slimfit':  ['weight loss','belly fat','metabolism','appetite control','body fat','waist size','cravings','weight management'],
    'pcos':     ['hormonal balance','irregular periods','PCOS symptoms','weight gain','acne from PCOS','mood swings','menstrual health','ovarian health'],
    'period':   ['period pain','menstrual cramps','irregular periods','heavy flow','PMS symptoms','mood swings','bloating during periods','menstrual discomfort'],
    'stree':    ['hormonal balance','women wellness','menstrual health','fertility support','PCOD','energy for women','reproductive health','female vitality'],
    'rasayan':  ['overall vitality','anti-aging','rejuvenation','energy','strength','immunity','youthfulness','longevity'],
    'lean':     ['detox','weight management','body cleansing','metabolism boost','toxin removal','bloating','sluggish metabolism','water retention'],
    'energy':   ['low energy','chronic fatigue','afternoon slump','lack of stamina','tiredness','physical weakness','daily energy','workout energy'],
    'liver':    ['liver health','fatty liver','liver detox','liver enzymes','liver function','toxin buildup','liver cleansing','digestive health']
  };

  var PRODUCT_TITLES_5 = {
    'pilo':      ['Piles pain gone completely!','No more bleeding — miracle product','Avoided surgery thanks to this','Best piles treatment without operation','Life-changing relief from hemorrhoids'],
    'gutfix':    ['Acidity gone in a week!','No more bloating after meals','Best digestive supplement ever','Stomach feels so much better','Gas and acidity problem solved'],
    'laxo':      ['Regular bowel movements now!','Constipation relief without dependency','Natural and gentle laxative','Stomach feels light every morning','Best herbal remedy for constipation'],
    'diacure':   ['Sugar levels are finally stable!','HbA1c dropped significantly','Best natural diabetes support','Doctor is impressed with my numbers','Managing diabetes naturally now'],
    'gluco':     ['Blood sugar under control!','No more sugar spikes after meals','Natural glucose management','My sugar readings improved a lot','Best sugar balance supplement'],
    'shilajit':  ['Energy levels through the roof!','Feeling 10 years younger','Incredible stamina boost','Best shilajit I have ever used','Pure and powerful product'],
    'vigora':    ['Feeling confident and strong again!','Amazing results in just 2 weeks','Best male health supplement','Stamina improved dramatically','Natural and effective formula'],
    'nightking': ['Incredible confidence boost!','Performance improved remarkably','Timing and stamina both better','My relationship improved so much','Best natural supplement for men'],
    'calmmind':  ['Anxiety reduced significantly!','Sleeping peacefully now','Mind feels calm and clear','No more overthinking at night','Best stress relief supplement'],
    'nidra':     ['Sleeping like a baby now!','Fall asleep within minutes','Best natural sleep aid','No groggy morning feeling','Insomnia problem finally solved'],
    'brainboost':['Memory has improved noticeably!','Focus during exams is amazing','Brain fog completely cleared','Concentration improved a lot','Best brain supplement for students'],
    'jointflex': ['Knee pain completely gone!','Can climb stairs again','Best joint supplement ever','No more morning stiffness','Moving freely after months'],
    'ortho':     ['Back pain relief in days!','Best pain relief oil ever','Muscle pain vanished quickly','Natural and effective pain relief','Chronic pain finally managed'],
    'hairgrow':  ['New hair growth is visible!','Hair fall reduced by 80%','Best hair growth oil','Bald patches filling up','Hair feels thicker and stronger'],
    'keshstrong':['Hair fall stopped completely!','Roots feel stronger now','Hair density improved visibly','Less hair on pillow every morning','Best anti-hairfall product'],
    'dandruff':  ['Dandruff gone in 2 washes!','Scalp feels clean and healthy','Best anti-dandruff shampoo','No more itchy scalp','Flakes disappeared completely'],
    'glowskin':  ['Skin is literally glowing!','Dark spots faded in weeks','Complexion improved naturally','Everyone asks my skin secret','Best skin brightening product'],
    'acnenil':   ['Pimples dried up in a week!','Acne scars fading visibly','Clear skin after years','Best natural acne treatment','Oil control is amazing'],
    'kumkumadi': ['Face looks radiant and young!','Dark circles reduced noticeably','Best kumkumadi oil quality','Skin texture transformed','Glow is visible from day one'],
    'immuno':    ['No more seasonal infections!','Immunity feels rock solid','Haven\'t fallen sick in months','Best immunity booster','Family stays healthy now'],
    'chyawan':   ['Energy and immunity both improved!','Best chyawanprash formula','No cough or cold this winter','Whole family loves it','Daily wellness transformed'],
    'fatty':     ['Liver enzymes normalized!','Doctor noticed improvement','Fatty liver reducing gradually','Best liver health supplement','Feeling lighter and healthier'],
    'slimfit':   ['Lost 5 kg in a month!','Belly fat visibly reducing','Appetite is under control','Metabolism feels faster','Best natural weight loss aid'],
    'pcos':      ['Periods became regular!','PCOS symptoms improved','Hormonal balance restored','Acne from PCOS reducing','Doctor is impressed with progress'],
    'period':    ['Period pain reduced so much!','Cramps are manageable now','PMS mood swings better','Flow became more regular','Best menstrual health product'],
    'stree':     ['Hormonal balance improved!','Feeling more energetic','Menstrual health is better','Best women\'s wellness product','Overall vitality increased'],
    'rasayan':   ['Feeling rejuvenated and young!','Energy levels improved','Best rasayan formula','Anti-aging effects visible','Vitality restored naturally'],
    'lean':      ['Body feels detoxed and light!','Metabolism improved','Water retention reduced','Best natural detox','Bloating problem solved'],
    'energy':    ['No more afternoon fatigue!','Energy lasts all day','Stamina improved in gym','Morning freshness is amazing','Best energy supplement']
  };

  function getProductKey(title) {
    var t = (title || '').toLowerCase();
    var keys = Object.keys(PRODUCT_CONCERNS);
    for (var i = 0; i < keys.length; i++) {
      if (t.indexOf(keys[i]) !== -1) return keys[i];
    }
    return '';
  }

  var productKey = getProductKey(productTitle);
  if (productKey && PRODUCT_CONCERNS[productKey]) {
    CONCERNS = PRODUCT_CONCERNS[productKey];
    // Merge product-specific 5-star titles into the template
    if (PRODUCT_TITLES_5[productKey]) {
      REVIEW_DATA[5].titles = PRODUCT_TITLES_5[productKey].concat(REVIEW_DATA[5].titles);
    }
  }

  var RELATIVES = ['mother','father','wife','husband','sister','brother','friend','colleague','aunt','uncle','grandmother'];
  var PROFESSIONS = ['doctor','pharmacist','nutritionist','yoga instructor','fitness trainer','Ayurveda practitioner','nurse','teacher','researcher'];

  /* ── Star Distribution Calculator ── */
  function calcDistribution(total, targetAvg10) {
    // targetAvg10: 45=4.5, 46=4.6, 47=4.7, 48=4.8, 49=4.9
    // Distributions calibrated to produce accurate weighted averages
    var avg = targetAvg10 / 10;
    var dist;
    if (avg >= 4.85) {
      // Weighted avg: 5×.93+4×.05+3×.012+2×.005+1×.003 = 4.90
      dist = { 5: 0.93, 4: 0.05, 3: 0.012, 2: 0.005, 1: 0.003 };
    } else if (avg >= 4.75) {
      // Weighted avg: 5×.86+4×.10+3×.025+2×.01+1×.005 = 4.80
      dist = { 5: 0.86, 4: 0.10, 3: 0.025, 2: 0.01, 1: 0.005 };
    } else if (avg >= 4.65) {
      // Weighted avg: 5×.80+4×.13+3×.04+2×.02+1×.01 = 4.69
      dist = { 5: 0.80, 4: 0.13, 3: 0.04, 2: 0.02, 1: 0.01 };
    } else if (avg >= 4.55) {
      // Weighted avg: 5×.75+4×.16+3×.05+2×.025+1×.015 = 4.61
      dist = { 5: 0.75, 4: 0.16, 3: 0.05, 2: 0.025, 1: 0.015 };
    } else {
      // Weighted avg: 5×.70+4×.18+3×.07+2×.03+1×.02 = 4.51
      dist = { 5: 0.70, 4: 0.18, 3: 0.07, 2: 0.03, 1: 0.02 };
    }
    var counts = {};
    var sum = 0;
    for (var s = 1; s <= 5; s++) {
      counts[s] = Math.round(total * dist[s]);
      sum += counts[s];
    }
    counts[5] += (total - sum); // adjust rounding
    return counts;
  }

  /* ── Human Randomness Patterns ── */
  var HINGLISH = [
    'Sach mein kamal ka product hai.',
    'Mujhe bahut acha laga, highly recommend.',
    'Pehle vishwas nahi tha but ab full bharosa hai.',
    'Meri family mein sabko pasand aaya.',
    'Bohot accha result mila, thank you Shiffa.',
    'Yaar kamaal hai ekdum, must try karo.',
    'Bahut din se search kar raha tha aisa kuch.',
    'Bilkul genuine product hai, no doubt.',
    'Maa ne bhi try kiya, unko bhi fayda hua.',
    'Paisa vasool product hai, 100%.',
    'Iske baad doosra product try karne ki zaroorat nahi.',
    'Dil se bol raha hoon, best hai ye.',
    'Arey waah, itna jaldi result aayega socha nahi tha.',
    'Bhai sahab, kya baat hai. Superb quality.',
    'Main toh fan ho gaya is product ka.'
  ];

  var EMOJI_ENDINGS = [
    ' 🙏', ' 👍', ' ❤️', ' 🌿', ' ✨', ' 💯', ' 🔥', ' 😊', ' 🙌', ' 💪',
    ' 👏', ' ⭐', ' 🎉', ' 😍', ' 💚', ' 🌸', ' 🤗'
  ];

  var UPDATE_PREFIXES = [
    'UPDATE after 3 months: ',
    'Edit — 2 months later: ',
    'UPDATE: After using for 6 months, ',
    'Updating my review after 4 weeks: ',
    'EDIT (after reorder): ',
    'Follow-up review: ',
    'Update after second bottle: '
  ];

  var SHORT_REVIEWS = [
    'Works great. Will reorder.',
    'Very effective, no complaints.',
    'Good product. Recommended by my doctor.',
    'Excellent quality. Fast delivery too.',
    'Using since 2 months. Happy with results.',
    'Genuine product, genuine results.',
    'Five stars from my side. Period.',
    'Best purchase I made this year.',
    'My go-to product now. Nothing else needed.',
    'Totally worth it.',
    'Finally something that actually works!',
    'Good stuff. Third time ordering.',
    'Exactly as described. Happy customer.',
    'Better than what I expected honestly.',
    'Simple review — it just works.',
    'No gimmicks here. Pure quality.',
    'Mast product hai. Repeat order done.',
    'Recommended to everyone I know.'
  ];

  /* Common Indian English typos & patterns */
  var TYPO_MAP = {
    'excellent': ['excelent','excellant'],
    'recommended': ['recomended','recommanded'],
    'definitely': ['definately','defintely'],
    'improvement': ['improvment','improovement'],
    'satisfied': ['satisfyed','satisifed'],
    'quality': ['qualty'],
    'product': ['prodcut','proudct'],
    'results': ['resutls','reults'],
    'effective': ['effectiv','efective'],
    'genuine': ['geniune','genuiene'],
    'experience': ['experiance','expreience'],
    'really': ['realy','relly'],
    'amazing': ['amzing','amazng'],
    'natural': ['natrual','natral'],
    'actually': ['actualy','acutally'],
    'medicine': ['medicne','medcine'],
    'treatment': ['tretment','treatmnt'],
    'noticed': ['noticde','noticd'],
    'months': ['moths','monts'],
    'family': ['famly','fmaily']
  };

  var FILLER_PHRASES = [
    ' Btw ', ' Also, ', ' And yes, ', ' By the way, ', ' Plus, ', ' One thing — ',
    ' On top of that, ', ' I should mention, '
  ];

  var EXTRA_SENTENCES = [
    'Delivery was also super fast.',
    'Packaging was neat and clean.',
    'My friends also want to try it now.',
    'Will definitely order again next month.',
    'The smell is also very pleasant and herbal.',
    'Customer support was helpful when I had questions.',
    'I compared with 3-4 other brands and this is clearly better.',
    'Even my doctor noticed the difference.',
    'Tried the cheaper alternatives first, waste of money honestly.',
    'This is my third reorder, that should say everything.',
    'Family pack would be great if Shiffa makes one!',
    'Been telling everyone at office about this.',
    'The ingredients list is impressive.',
    'No artificial smell or colour, thats what I like.',
    'Shipping could be a day faster but product is A+.'
  ];

  function humanize(text, title, starRating) {
    var r = rng();

    // ~12% chance: replace with a short punchy review
    if (r < 0.12 && starRating >= 4) {
      return { body: pick(SHORT_REVIEWS), title: title };
    }

    // ~8% chance: add Hinglish sentence
    if (rng() < 0.08) {
      text = text + ' ' + pick(HINGLISH);
    }

    // ~10% chance: add emoji at the end
    if (rng() < 0.10) {
      text = text.replace(/\.$/, '') + pick(EMOJI_ENDINGS);
    }

    // ~6% chance: add UPDATE prefix (only for 4-5 star reviews)
    if (rng() < 0.06 && starRating >= 4) {
      var prefix = pick(UPDATE_PREFIXES);
      text = prefix + text.charAt(0).toLowerCase() + text.slice(1);
      title = 'Updated Review — ' + title;
    }

    // ~7% chance: introduce a common typo
    if (rng() < 0.07) {
      var typoKeys = Object.keys(TYPO_MAP);
      var typoWord = typoKeys[Math.floor(rng() * typoKeys.length)];
      var lower = text.toLowerCase();
      if (lower.indexOf(typoWord) !== -1) {
        var replacement = TYPO_MAP[typoWord][Math.floor(rng() * TYPO_MAP[typoWord].length)];
        // Replace first occurrence preserving case of first letter
        var idx = lower.indexOf(typoWord);
        var original = text.substr(idx, typoWord.length);
        var wasUpper = original.charAt(0) === original.charAt(0).toUpperCase();
        if (wasUpper) replacement = replacement.charAt(0).toUpperCase() + replacement.slice(1);
        text = text.substring(0, idx) + replacement + text.substring(idx + typoWord.length);
      }
    }

    // ~10% chance: add a filler phrase + extra sentence
    if (rng() < 0.10) {
      text = text.replace(/\.$/, '') + '.' + pick(FILLER_PHRASES) + pick(EXTRA_SENTENCES).toLowerCase();
    }

    // ~8% chance: add an extra sentence at the end
    if (rng() < 0.08) {
      text = text + ' ' + pick(EXTRA_SENTENCES);
    }

    // ~6% chance: enthusiastic punctuation (!! or !!!)
    if (rng() < 0.06 && starRating >= 4) {
      text = text.replace(/\.([^.]*)$/, '!!' + '$1');
    }

    // ~5% chance: add trailing "..." for lower ratings
    if (rng() < 0.05 && starRating <= 3) {
      text = text.replace(/\.$/, '...');
    }

    // ~4% chance: drop period at end (casual style)
    if (rng() < 0.04) {
      text = text.replace(/\.\s*$/, '');
    }

    // ~3% chance: ALL CAPS a positive word
    if (rng() < 0.03 && starRating >= 4) {
      var capsWords = ['amazing','incredible','excellent','best','superb','fantastic','outstanding','genuine','miracle','wonderful'];
      for (var w = 0; w < capsWords.length; w++) {
        if (text.toLowerCase().indexOf(capsWords[w]) !== -1) {
          var ci = text.toLowerCase().indexOf(capsWords[w]);
          text = text.substring(0, ci) + text.substr(ci, capsWords[w].length).toUpperCase() + text.substring(ci + capsWords[w].length);
          break;
        }
      }
    }

    // ~5% chance: add "P.S." note
    if (rng() < 0.05 && starRating >= 4) {
      var ps = [
        'P.S. — Already ordered for my parents too.',
        'P.S. Please never discontinue this product!',
        'PS — packaging was also really beautiful.',
        'P.S. Customer care team is also very helpful.',
        'PS: Waiting for more Shiffa products to try!'
      ];
      text = text + ' ' + pick(ps);
    }

    return { body: text, title: title };
  }

  /* ── Generate Reviews ── */
  function generateReviews(total, starCounts) {
    var reviews = [];
    var now = Date.now();
    var oneDay = 86400000;

    for (var stars = 5; stars >= 1; stars--) {
      for (var i = 0; i < starCounts[stars]; i++) {
        var data = REVIEW_DATA[stars];
        var title = pick(data.titles);
        var body = pick(data.bodies);
        var concern = pick(CONCERNS);
        var relative = pick(RELATIVES);
        var profession = pick(PROFESSIONS);
        var months = randInt(1, 12);
        var weeks = randInt(2, 8);
        var recommend = randInt(5, 20);

        body = body
          .replace(/{concern}/g, concern)
          .replace(/{months}/g, months)
          .replace(/{weeks}/g, weeks)
          .replace(/{relative}/g, relative)
          .replace(/{profession}/g, profession)
          .replace(/{recommend}/g, recommend);

        // Apply human randomness patterns
        var humanized = humanize(body, title, stars);
        body = humanized.body;
        title = humanized.title;

        var firstName = pick(FIRST_NAMES);
        var lastName = pick(LAST_NAMES);
        var daysAgo = randInt(5, 730);
        var helpful = stars >= 4 ? randInt(5, 180) : randInt(0, 30);
        var hasPhotos = rng() < 0.12;
        var verified = rng() < 0.92;
        var city = pick(CITIES);

        reviews.push({
          id: 'gen_' + stars + '_' + i,
          name: firstName + ' ' + lastName.charAt(0) + '.',
          initials: firstName.charAt(0) + lastName.charAt(0),
          city: city,
          stars: stars,
          title: title,
          body: body,
          date: now - (daysAgo * oneDay),
          helpful: helpful,
          verified: verified,
          hasPhotos: hasPhotos,
          isUser: false
        });
      }
    }

    // Shuffle using Fisher-Yates with seeded rng
    for (var j = reviews.length - 1; j > 0; j--) {
      var k = Math.floor(rng() * (j + 1));
      var temp = reviews[j];
      reviews[j] = reviews[k];
      reviews[k] = temp;
    }

    return reviews;
  }

  /* ── localStorage User Reviews ── */
  var STORAGE_KEY = 'shiffa_reviews_' + productId;

  function getUserReviews() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) { return []; }
  }

  function saveUserReview(review) {
    var reviews = getUserReviews();
    reviews.unshift(review);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(reviews));
    } catch (e) {}
  }

  function getLikedReviews() {
    try {
      var d = localStorage.getItem('shiffa_liked_reviews');
      return d ? JSON.parse(d) : {};
    } catch(e) { return {}; }
  }

  function toggleLike(reviewId) {
    var liked = getLikedReviews();
    if (liked[reviewId]) {
      delete liked[reviewId];
    } else {
      liked[reviewId] = true;
    }
    try {
      localStorage.setItem('shiffa_liked_reviews', JSON.stringify(liked));
    } catch(e) {}
    return !!liked[reviewId];
  }

  /* ── Format Helpers ── */
  function formatDate(ts) {
    var d = new Date(ts);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function timeAgo(ts) {
    var diff = Date.now() - ts;
    var days = Math.floor(diff / 86400000);
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return days + ' days ago';
    if (days < 30) return Math.floor(days / 7) + ' weeks ago';
    if (days < 365) return Math.floor(days / 30) + ' months ago';
    return Math.floor(days / 365) + ' year' + (Math.floor(days / 365) > 1 ? 's' : '') + ' ago';
  }

  function starsHTML(count, cls) {
    cls = cls || 'sr-card__star';
    var h = '';
    for (var i = 1; i <= 5; i++) {
      h += '<span class="' + cls + (i > count ? ' ' + cls + '--off' : '') + '">★</span>';
    }
    return h;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ── Compute Actual Average ── */
  function computeAvg(reviews) {
    if (!reviews.length) return 0;
    var sum = 0;
    reviews.forEach(function (r) { sum += r.stars; });
    return (sum / reviews.length).toFixed(1);
  }

  /* ── Build Summary ── */
  function renderSummary(allReviews) {
    var avg = computeAvg(allReviews);
    var total = allReviews.length;
    var counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    allReviews.forEach(function (r) { counts[r.stars]++; });

    document.getElementById('sr-avg-rating').textContent = avg;
    document.getElementById('sr-total-count').textContent = total.toLocaleString('en-IN');

    // Stars
    var avgStars = document.getElementById('sr-avg-stars');
    var avgNum = parseFloat(avg);
    var fullStars = Math.floor(avgNum);
    var hasHalf = (avgNum - fullStars) >= 0.3;
    var sh = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        sh += '<span class="sr-summary__star">★</span>';
      } else if (i === fullStars + 1 && hasHalf) {
        sh += '<span class="sr-summary__star sr-summary__star--half">★</span>';
      } else {
        sh += '<span class="sr-summary__star sr-summary__star--empty">★</span>';
      }
    }
    avgStars.innerHTML = sh;

    // Bars
    var barsEl = document.getElementById('sr-bars');
    var bh = '';
    for (var s = 5; s >= 1; s--) {
      var pct = total > 0 ? Math.round((counts[s] / total) * 100) : 0;
      bh += '<div class="sr-bar">' +
        '<span class="sr-bar__label">' + s + ' ★</span>' +
        '<div class="sr-bar__track"><div class="sr-bar__fill" style="width:' + pct + '%"></div></div>' +
        '<span class="sr-bar__pct">' + pct + '%</span>' +
        '</div>';
    }
    barsEl.innerHTML = bh;
  }

  /* ── Render Review Card ── */
  function reviewCardHTML(r) {
    var liked = getLikedReviews();
    var isLiked = !!liked[r.id];
    var helpCount = r.helpful + (isLiked ? 1 : 0);

    var photoHTML = '';
    if (r.hasPhotos) {
      var photoEmojis = ['📸', '🌿', '📦'];
      photoHTML = '<div class="sr-card__img-row">';
      for (var p = 0; p < randInt(1, 3); p++) {
        photoHTML += '<div class="sr-card__img">' + photoEmojis[p % 3] + '</div>';
      }
      photoHTML += '</div>';
    }

    return '<div class="sr-card' + (r.isUser ? ' sr-card--user' : '') + '" data-review-id="' + r.id + '">' +
      '<div class="sr-card__top">' +
        '<div class="sr-card__user">' +
          '<div class="sr-card__avatar">' + escapeHTML(r.initials) + '</div>' +
          '<div>' +
            '<div class="sr-card__name">' + escapeHTML(r.name) + '</div>' +
            '<div class="sr-card__meta">' +
              '<span>📍 ' + escapeHTML(r.city) + '</span>' +
              (r.verified ? '<span class="sr-card__verified">✓ Verified</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div>' +
          '<div class="sr-card__stars">' + starsHTML(r.stars) + '</div>' +
          '<div class="sr-card__date">' + formatDate(r.date) + '</div>' +
        '</div>' +
      '</div>' +
      '<h4 class="sr-card__title">' + escapeHTML(r.title) + '</h4>' +
      '<p class="sr-card__body">' + escapeHTML(r.body) + '</p>' +
      photoHTML +
      '<div class="sr-card__footer">' +
        '<button class="sr-card__helpful' + (isLiked ? ' sr-liked' : '') + '" data-rid="' + r.id + '">👍 Helpful (' + helpCount + ')</button>' +
        (r.hasPhotos ? '<span class="sr-card__photos-badge">📷 With Photos</span>' : '') +
        (r.isUser ? '<span class="sr-card__tag">Your Review</span>' : '') +
      '</div>' +
    '</div>';
  }

  /* ── Main Engine ── */
  var starCounts = calcDistribution(TOTAL_REVIEWS, TARGET_RATING_X10);
  var generatedReviews = generateReviews(TOTAL_REVIEWS, starCounts);
  var allReviews = getUserReviews().concat(generatedReviews);

  var currentFilter = 'all';
  var currentSort = 'newest';
  var currentPage = 1;

  function getFilteredSorted() {
    var filtered = allReviews;
    if (currentFilter !== 'all') {
      var s = parseInt(currentFilter, 10);
      filtered = filtered.filter(function (r) { return r.stars === s; });
    }

    filtered.sort(function (a, b) {
      switch (currentSort) {
        case 'newest': return b.date - a.date;
        case 'oldest': return a.date - b.date;
        case 'highest': return b.stars - a.stars;
        case 'lowest': return a.stars - b.stars;
        case 'helpful': return b.helpful - a.helpful;
        default: return 0;
      }
    });

    // Always put user reviews first
    var userR = filtered.filter(function (r) { return r.isUser; });
    var otherR = filtered.filter(function (r) { return !r.isUser; });
    return userR.concat(otherR);
  }

  function render() {
    var filtered = getFilteredSorted();
    var visible = filtered.slice(0, currentPage * PER_PAGE);
    var grid = document.getElementById('sr-grid');
    var loadSection = document.getElementById('sr-load');
    var loadInfo = document.getElementById('sr-load-info');

    grid.innerHTML = visible.map(reviewCardHTML).join('');

    // Load more visibility
    if (visible.length < filtered.length) {
      loadSection.style.display = '';
      loadInfo.textContent = 'Showing ' + visible.length.toLocaleString('en-IN') + ' of ' + filtered.length.toLocaleString('en-IN') + ' reviews';
    } else {
      loadSection.style.display = 'none';
    }

    // Attach helpful button listeners
    grid.querySelectorAll('.sr-card__helpful').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rid = this.dataset.rid;
        var nowLiked = toggleLike(rid);
        this.classList.toggle('sr-liked', nowLiked);
        // Update count display
        var review = allReviews.find(function (r) { return r.id === rid; });
        if (review) {
          var cnt = review.helpful + (nowLiked ? 1 : 0);
          this.textContent = '👍 Helpful (' + cnt + ')';
        }
      });
    });
  }

  /* ── Initial Render ── */
  renderSummary(allReviews);
  render();

  /* ── Filter Buttons ── */
  var filterBtns = document.querySelectorAll('#sr-filters .sr-filter');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('sr-active'); });
      this.classList.add('sr-active');
      currentFilter = this.dataset.stars;
      currentPage = 1;
      render();
    });
  });

  /* ── Sort Select ── */
  var sortSel = document.getElementById('sr-sort');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      currentSort = this.value;
      currentPage = 1;
      render();
    });
  }

  /* ── Load More ── */
  var loadBtn = document.getElementById('sr-load-btn');
  if (loadBtn) {
    loadBtn.addEventListener('click', function () {
      currentPage++;
      render();
      // Scroll to new content
      var grid = document.getElementById('sr-grid');
      var cards = grid.querySelectorAll('.sr-card');
      if (cards.length > PER_PAGE) {
        var target = cards[cards.length - PER_PAGE];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  /* ── Write Review Modal ── */
  var modal = document.getElementById('sr-modal');
  var writeBtn = document.getElementById('sr-write-btn');
  var closeBtn = document.getElementById('sr-modal-close');
  var submitBtn = document.getElementById('sr-submit');
  var modalForm = document.getElementById('sr-modal-form');
  var modalSuccess = document.getElementById('sr-modal-success');
  var selectedRating = 0;

  if (writeBtn) {
    writeBtn.addEventListener('click', function () {
      modal.classList.add('sr-open');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeModal() {
    modal.classList.remove('sr-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }

  // Star selection
  var modalStars = document.querySelectorAll('#sr-modal-stars .sr-modal__star');
  modalStars.forEach(function (star) {
    star.addEventListener('click', function () {
      selectedRating = parseInt(this.dataset.rating, 10);
      modalStars.forEach(function (s) {
        s.classList.toggle('sr-selected', parseInt(s.dataset.rating, 10) <= selectedRating);
      });
      validateForm();
    });
    star.addEventListener('mouseenter', function () {
      var hoverVal = parseInt(this.dataset.rating, 10);
      modalStars.forEach(function (s) {
        s.classList.toggle('sr-selected', parseInt(s.dataset.rating, 10) <= hoverVal);
      });
    });
    star.addEventListener('mouseleave', function () {
      modalStars.forEach(function (s) {
        s.classList.toggle('sr-selected', parseInt(s.dataset.rating, 10) <= selectedRating);
      });
    });
  });

  // Form validation
  var inputName = document.getElementById('sr-input-name');
  var inputTitle = document.getElementById('sr-input-title');
  var inputBody = document.getElementById('sr-input-body');

  function validateForm() {
    var valid = selectedRating > 0 &&
      inputName && inputName.value.trim().length >= 2 &&
      inputTitle && inputTitle.value.trim().length >= 3 &&
      inputBody && inputBody.value.trim().length >= 10;
    if (submitBtn) submitBtn.disabled = !valid;
  }

  [inputName, inputTitle, inputBody].forEach(function (el) {
    if (el) el.addEventListener('input', validateForm);
  });

  // Submit
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;

      var name = inputName.value.trim();
      var review = {
        id: 'user_' + Date.now(),
        name: name,
        initials: name.split(' ').map(function (w) { return w.charAt(0); }).join('').substring(0, 2).toUpperCase(),
        city: 'India',
        stars: selectedRating,
        title: inputTitle.value.trim(),
        body: inputBody.value.trim(),
        date: Date.now(),
        helpful: 0,
        verified: true,
        hasPhotos: false,
        isUser: true
      };

      saveUserReview(review);
      allReviews.unshift(review);

      // Show success
      modalForm.style.display = 'none';
      modalSuccess.style.display = '';

      // Reset form
      selectedRating = 0;
      inputName.value = '';
      inputTitle.value = '';
      inputBody.value = '';
      modalStars.forEach(function (s) { s.classList.remove('sr-selected'); });
      submitBtn.disabled = true;

      // Update summary and list
      renderSummary(allReviews);
      currentPage = 1;
      currentFilter = 'all';
      filterBtns.forEach(function (b) { b.classList.toggle('sr-active', b.dataset.stars === 'all'); });
      render();

      // Auto close after 2s
      setTimeout(function () {
        closeModal();
        modalForm.style.display = '';
        modalSuccess.style.display = 'none';
      }, 2500);
    });
  }

  /* ── Scroll Animation ── */
  if ('IntersectionObserver' in window) {
    var cards = document.querySelectorAll('.sr-summary, .sr-controls');
    cards.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .5s ease, transform .5s ease';
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    cards.forEach(function (el) { obs.observe(el); });
  }

})();
